import React from 'react';
import { Link } from 'react-router-dom';

import { Bloc } from '@mairistem/administres-utils';
import { Icon, Checkbox, type CheckboxProps } from '@mairistem/composants';

import { useEntiteStore } from '@/zustand';
import { TypeListePacs } from '@/enums';
import PacsListeContainer from '@/components/Pacs/Liste/PacsListeContainer';

interface BlocListeProps {
  style?: React.CSSProperties;
}

const BlocListe = (props: BlocListeProps) => {
  const { style } = props;
  const [showAll, setShowAll] = React.useState(false);
  const blocked = useEntiteStore((state) => state.blocked);

  if (blocked) {
    return null;
  }

  return (
    <Bloc icon="search" header="Recherche d'un pacs" style={style}>
      <PacsListeContainer
        data-testid="pacs-liste-dashboard"
        key={`pacs-container-${showAll}`}
        typeListe={
          showAll
            ? `${TypeListePacs.ToutPacs}`
            : `${TypeListePacs.PacsProjet},${TypeListePacs.PacsEnCours}`
        }
        // all={showAll}
        dashboard
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: '1.5em',
        }}
      >
        <Checkbox
          toggle
          data-testid="bloc-liste-checkbox-afficher-tout"
          label="Afficher les PACS n'ayant pas cours"
          checked={showAll}
          onChange={(
            _e: React.FormEvent<HTMLInputElement>,
            data: CheckboxProps,
          ) => setShowAll(data.checked as boolean)}
        />
        <Link
          to="/pacs/all"
          data-testid="bloc-liste-lien-voir-tout"
          style={{
            display: 'block',
            color: 'inherit',
            cursor: 'pointer',
            textDecoration: 'none',
          }}
        >
          Voir tout
          <Icon
            name="arrow right"
            style={{
              border: '1px solid grey',
              padding: '0.7em',
              borderRadius: '4px',
              display: 'inline',
              marginLeft: '15px',
            }}
          />
        </Link>
      </div>
    </Bloc>
  );
};

export default BlocListe;
